var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAvgRatingBinding)?_c('AverageRating'):_c('ResponsiveComponent',{scopedSlots:_vm._u([{key:"mobile",fn:function(){return [_c('LayoutTwoMobile')]},proxy:true},{key:"desktop",fn:function(){return [_c('LayoutTwoDesktop')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }